export const WEEKDAYS = [
  { value: 0, label: "Dimanche" },
  { value: 1, label: "Lundi" },
  { value: 2, label: "Mardi" },
  { value: 3, label: "Mercredi" },
  { value: 4, label: "Jeudi" },
  { value: 5, label: "Vendredi" },
  { value: 6, label: "Samedi" },
] as const;

export function dayLabel(day: number): string {
  return WEEKDAYS.find((d) => d.value === day)?.label ?? `Jour ${day}`;
}

const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];

export function formatFrenchDay(value: string): string {
  const day = (value || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return value || "";
  const [y, m, d] = day.split("-").map(Number);
  const month = MONTHS[m - 1];
  if (!month) return value;
  return `${d} ${month} ${y}`;
}

export function formatClock(hhmm: string): string {
  const raw = (hhmm || "").replace(":", "");
  if (raw.length < 3) return hhmm || "—";
  const h = raw.slice(0, -2).padStart(2, "0");
  const m = raw.slice(-2);
  return `${h}:${m}`;
}
